import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class SearchBar extends Component {
  render() {
    return (
      <div className="col input-group">
        <input
          type="search"
          className="form-control search-clear"
          placeholder="Search"
          aria-label="Search"
          value={this.props.term}
          onChange={this.props.onChange}
        />
        {this.props.showNewButton && (
          <div className="input-group-append">
            <button className="btn btn-outline-info" type="button">
              <Link
                to={this.props.newButtonRoute}
                className="buttonLink text-info"
              >
                {this.props.newButtonLabel}
              </Link>
            </button>
          </div>
        )}
      </div>
    );
  }
}

SearchBar.propTypes = {
  term: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showNewButton: PropTypes.bool,
  newButtonRoute: PropTypes.string,
  newButtonLabel: PropTypes.string
};

SearchBar.defaultProps = {
  term: '',
  newButtonLabel: '+ New'
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/modules/misc/components/SearchBar.js